import ReviewLinks from './ReviewLinks';
import ReviewWholescale from './ReviewWholescale';
import ReviewYotpo from './ReviewYotpo';
import TextSubmit from './TextSubmit';
import TiktokPublish from './TiktokPublish';
import UrlSubmit from './UrlSubmit';

const index = {
  ReviewLinks,
  ReviewWholescale,
  ReviewYotpo,
  TextSubmit,
  TiktokPublish,
  UrlSubmit,
};

export default index;